// @ts-nocheck
import {
    loadQuoteAdditionalInfo,
    loadQuoteDetailsDocuments,
    loadQuoteDetailsUploadMsg,
    loadQuoteLastModifiedOn,
} from "@store/Framework/Store/Store/Pages/RfqQuoteDetails/StoreRfqQuoteDetailsSelectors";
import { useSelector } from "react-redux";

export const useQuoteLastModifiedOn = () => useSelector(loadQuoteLastModifiedOn);

export const useRfqDetailsDocuments = () => useSelector(loadQuoteDetailsDocuments);

export const useRfqDetailsUploadMsg = () => useSelector(loadQuoteDetailsUploadMsg);

export const useQuoteAdditionalInfo = () => useSelector(loadQuoteAdditionalInfo);
